/**
 * Paleta de cores oficial do PG Custom, já usada no storefront desde
 * antes do ERP existir: charcoal (fundo), azul elétrico (destaque de
 * loja), dourado (reservado a UI administrativa/operacional — este é
 * o contexto do ERP).
 *
 * `color-roxo`/`color-roxo-hover` são ADITIVOS (fase de finalização,
 * dashboards de perfil — CEO/Financeiro/Sócio/Colaborador/Parceiro/
 * Técnico) — extraídos das referências visuais fornecidas pelo owner
 * para esta etapa (roxo + dourado + preto, "aparência de ERP premium").
 * Nunca substituem `color-destaque` (azul): páginas já existentes do
 * ERP interno continuam azuis, roxo é o acento novo específico dos
 * dashboards de perfil.
 *
 * Cada token vira uma variável CSS (`--pg-color-*`), a única forma
 * permitida de referenciar cor em qualquer componente do Design System
 * (CODING_STANDARDS.md, seção 16 — nenhum valor mágico fora dos tokens).
 */
export const COLORS = {
    'color-bg-base': '#121417',
    'color-bg-elevado': '#1a1d21',
    'color-bg-hover': '#22262b',
    'color-borda': '#2a2f36',
    'color-texto-primario': '#f2f3f5',
    'color-texto-secundario': '#9aa1ab',
    'color-texto-desabilitado': '#5c626b',
    'color-destaque': '#2f8cff',
    'color-destaque-hover': '#5aa3ff',
    'color-dourado': '#c9a24b',
    'color-dourado-hover': '#dab766',
    'color-roxo': '#8b5cf6',
    'color-roxo-hover': '#a78bfa',
    'color-sucesso': '#3bb273',
    'color-alerta': '#e0a52c',
    'color-erro': '#e5484d',
    'color-rosa-pg-art': '#e05f9b',
};
//# sourceMappingURL=colors.js.map